import firebase from "firebase";
import Vue from "vue";

import { Dispatcher } from "@/store/helper/firestore";

import uuid from "uuid";
import _ from "lodash";

export const api = {
  namespace: "templates",
  getters: {
    loadedAudits: "loadedAudits",
    loadedAudit: "loadedAudit",
    getDialogItem: "getDialogItem",
    getDialogAction: "getDialogAction",
    getAuditId: "getAuditId",
    getAuditItemId: "getAuditItemId"
  },
  mutations: {
    resetState: "resetState",
    setloadedTemplates: "setloadedTemplates",
    createAudit: "createAudit",
    updateAudit: "updateAudit",
    deleteAudit: "deleteAudit",
    createAuditItem: "createAuditItem",
    updateAuditItem: "updateAuditItem",
    deleteAuditItem: "deleteAuditItem",
    createTemplate: "createTemplate",
    setDialogItem: "setDialogItem",
    setDialogAction: "setDialogAction",
    setAuditId: "setAuditId",
    setAuditItemId: "setAuditItemId"
  },
  actions: {
    loadAudits: "loadAudits",
    setloadedAudits: "setloadedAudits",
    createAudit: "createAudit",
    updateAudit: "updateAudit",
    deleteAudit: "deleteAudit",
    createAuditItem: "createAuditItem",
    updateAuditItem: "updateAuditItem",
    deleteAuditItem: "deleteAuditItem",
    createTemplate: "createTemplate",
    importActionSet: "importActionSet",
    setDialogItem: "setDialogItem",
    setDialogAction: "setDialogAction",
    setAuditId: "setAuditId",
    setAuditItemId: "setAuditItemId"
  },
  state: {
    loadedAudits: "loadedAudits",
    currentDialogItem: "currentDialogItem",
    currentDialogAction: "currentDialogAction",
    currentAuditId: "currentAuditId",
    currentAuditItemId: "currentAuditItemId"
  }
};

const defaultState = () => {
  return {
    [api.state.loadedAudits]: [],
    [api.state.currentDialogItem]: {},
    [api.state.currentDialogAction]: null,
    [api.state.currentAuditId]: null,
    [api.state.currentAuditItemId]: null
  };
};

const state = defaultState();

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.setDialogItem](state, payload) {
    state.currentDialogItem = payload;
  },
  [api.mutations.setDialogAction](state, payload) {
    state.currentDialogAction = payload;
  },
  [api.mutations.setAuditId](state, payload) {
    state.currentAuditId = payload;
  },
  [api.mutations.setAuditItemId](state, payload) {
    state.currentAuditItemId = payload;
  },
  [api.mutations.setloadedTemplates](state, payload) {
    const templates = _.map(payload, (v, id) => {
      return { audit_items: {}, ...v, id };
    });
    const keyed_templates = _.keyBy(templates, "id");

    state.loadedAudits = keyed_templates;
  },
  [api.mutations.createAudit](state, payload) {
    const audit_id = payload.item_id;
    Vue.set(state.loadedAudits, audit_id, {
      audit_items: {},
      ...payload.data,
      id: audit_id
    });
  },
  [api.mutations.deleteAudit](state, payload) {
    const audit_id = payload.audit_id;
    Vue.delete(state.loadedAudits, audit_id);
  },
  [api.mutations.updateAuditItem](state, payload) {
    const data = payload.data;
    const audit_id = payload.audit_id;
    const audititem_id = payload.audititem_id;

    console.log(
      "Updating AuditItem: audit_id:" +
        audit_id +
        "audititem_id:" +
        audititem_id
    );

    Vue.set(state.loadedAudits[audit_id].audit_items, audititem_id, data);
  },
  [api.mutations.deleteAuditItem](state, payload) {
    const audit_id = payload.audit_id;
    const audititem_id = payload.audititem_id;

    Vue.delete(state.loadedAudits[audit_id].audit_items, audititem_id);
  },
  [api.mutations.updateAudit](state, payload) {
    const data = payload.data;
    const audit_id = payload.audit_id;

    const new_data = { ...state.loadedAudits[audit_id], ...data };
    Object.assign(state.loadedAudits[audit_id], new_data);
  },
  [api.mutations.createAuditItem](state, payload) {
    const audit_id = payload.audit_id;
    //const audititem_id = payload.audititem_id || uuid.v4();
    const data = payload.data;

    console.log("Creating Audit Item");
    console.log(audit_id);
    console.log(data);

    const check = state.loadedAudits[audit_id].audit_items;

    if (!check) {
      Vue.set(state.loadedAudits[audit_id], "audit_items", {});
    }

    // TODO: Hotfix to be checked
    for (let key in data) {
      Vue.set(state.loadedAudits[audit_id].audit_items, key, data[key]);
    }
  }
};

const actions = {
  async [api.actions.setDialogItem]({ commit }, payload) {
    commit("setDialogItem", _.cloneDeep(payload));
  },
  async [api.actions.setDialogAction]({ commit }, payload) {
    commit("setDialogAction", payload);
  },
  async [api.actions.setAuditId]({ commit }, payload) {
    commit("setAuditId", payload);
  },
  async [api.actions.setAuditItemId]({ commit }, payload) {
    commit("setAuditItemId", payload);
  },
  async [api.actions.createAudit]({ commit, dispatch }, payload) {
    const activity = payload.activity;

    const ref = "templates";
    const mutation = "createAudit";
    const child = "";

    console.log("Create Audit in Firebase");
    console.log(payload);

    let object_id = await Dispatcher.createAsync({
      ref,
      child,
      payload,
      commit,
      mutation
    });

    dispatch(
      "activities/createActivity",
      { ...activity, object: object_id, object_url: "/templates/" + object_id },
      { root: true }
    );

    return object_id;
  },
  [api.actions.loadAudits]({ commit, dispatch }) {
    dispatch("app/setLoading", false, { root: true });

    firebase
      .firestore()
      .collection("templates")
      .get()
      .then(snapshot => {
        console.log("Fetch data from firebase");
        const templates = {};

        snapshot.forEach(doc => {
          templates[doc.id] = {
            ...doc.data(),
            id: doc.id
          };
        });

        commit(api.mutations.setloadedTemplates, templates);
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );

        dispatch("app/setLoading", false, { root: true });
      });
  },
  [api.actions.updateAudit]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    payload = _.cloneDeep(payload);

    const audit_id = payload.audit_id;
    const activity = payload.activity;
    delete payload.data.audit_items;

    console.log("Payload", payload);

    const ref = "templates";
    const doc = audit_id;
    const mutation = "updateAudit";

    Dispatcher.updateAsync({ ref, doc, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );
        dispatch("app/setLoading", false, { root: true });
      });

    dispatch("activities/createActivity", activity, { root: true });
  },
  [api.actions.deleteAudit]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const audit_id = payload.audit_id;

    const ref = "templates";
    const doc = audit_id;
    const mutation = "deleteAudit";

    Dispatcher.deleteAsync({ ref, doc, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );

        dispatch("app/setLoading", false, { root: true });
      });

    //dispatch("activities/createActivity", activity, { root: true });
  },
  async [api.actions.createAuditItem]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const audit_id = payload.audit_id;
    const data = payload.data;

    const ref = "templates";
    const doc = audit_id;
    const mutation = "createAuditItem";
    const child = "audit_items";

    const go = _.keyBy(data, () => {
      return uuid.v4();
    });
    payload = { ...payload, data: go };

    console.log("Go", payload);
    Dispatcher.setAsync({ ref, doc, child, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
        dispatch(
          "app/addStatus",
          { message: "Audit item successfully created", type: "success" },
          { root: true }
        );
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );

        dispatch("app/setLoading", false, { root: true });
      });
  },
  [api.actions.updateAuditItem]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const audit_id = payload.audit_id;
    const audititem_id = payload.audititem_id;

    const ref = "templates";
    const doc = audit_id;
    const child = "audit_items." + audititem_id;
    const mutation = "updateAuditItem";

    console.log("Updating AuditItem in Firebase");
    console.log(audit_id + "-" + audititem_id);
    console.log(payload);

    Dispatcher.updateAsync({ ref, doc, child, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );

        dispatch("app/setLoading", false, { root: true });
      });
  },
  async [api.actions.deleteAuditItem]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });
    const audit_id = payload.audit_id;
    const audititem_id = payload.audititem_id;

    const ref = "templates";
    const doc = audit_id;
    const child = "audit_items." + audititem_id;
    const mutation = "deleteAuditItem";

    payload = { ...payload, data: firebase.firestore.FieldValue.delete() };

    Dispatcher.updateAsync({ ref, doc, child, payload, commit, mutation })
      .then(() => {
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(err => {
        console.error(err);
        dispatch(
          "app/addStatus",
          {
            message: err.message,
            type: "error"
          },
          { root: true }
        );

        dispatch("app/setLoading", false, { root: true });
      });
  },
  [api.actions.importActionSet]({ dispatch }, payload) {
    const vdadata = vdatemplate;

    //console.debug(vdadata);

    for (const key in vdadata) {
      const local_question = { ...vdadata[key], chapters: {} };

      const audit_item = [{ question: local_question, deviations: {} }];

      const new_payload = { audit_id: payload.audit_id, data: audit_item };

      dispatch("createAuditItem", { ...new_payload });
    }
  }
};

const getters = {
  [api.getters.getDialogItem](state) {
    return state.currentDialogItem;
  },
  [api.getters.getDialogAction](state) {
    return state.currentDialogAction;
  },
  [api.getters.getAuditId](state) {
    return state.currentAuditId;
  },
  [api.getters.getAuditItemId](state) {
    return state.currentAuditItemId;
  },
  [api.getters.loadedAudits](state) {
    return _.map(state.loadedAudits);
  },
  [api.getters.loadedAudit](state) {
    return auditId => state.loadedAudits[auditId];
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};

export const vdatemplate = [
  {
    category: 2,
    text:
      "Ist die Projektorganisation (Projektleitung) etabliert und die Aufgaben sowie Kompetenzen der Projektleitung, Teammitglieder festgelegt? ",
    description: ""
  },
  {
    category: 2,
    text:
      "Sind für die Projektabwicklung die erforderlichen Ressourcen geplant, vorhanden und werden Änderungen angezeigt?",
    description: ""
  },
  {
    category: 2,
    text: "Ist ein Projektplan vorhanden und mit dem Kunden abgestimmt?",
    description: ""
  },
  {
    category: 2,
    text:
      "Wird das Änderungsmanagement im Projekt durch die Projektorganisation sichergestellt?",
    description: ""
  },
  {
    category: 2,
    text:
      "Sind die Verantwortlichen Personen in der Organisation und beim Kunden im Änderungsdienst eingebunden?",
    description: ""
  },
  {
    category: 2,
    text:
      "Gibt es im Projekt einen Q-Plan und wird dieser umgesetzt und regelmässig auf Einhaltung überwacht?",
    description: ""
  },
  {
    category: 2,
    text:
      "Ist ein Eskalationsprozess etabliert und ist dieser wirksam umgesetzt? ",
    description: ""
  },
  {
    category: 3,
    text: "Liegen die produkt- und prozessspezifischen Anforderungen vor?",
    description: ""
  },
  {
    category: 3,
    text:
      "Ist die Herstellbarkeit auf Basis der ermittelten Anforderungen an das Produkt und den Prozess übergreifend bewertet?",
    description: ""
  },
  {
    category: 3,
    text: "Sind Pläne zur Produkt- und Prozessentwicklung vorhanden?",
    description: ""
  },
  {
    category: 3,
    text:
      "Sind für die Produkt- und Prozessentwicklung die erforderlichen Ressourcen berücksichtigt?",
    description: ""
  },
  {
    category: 3,
    text: "Liegen für die Beschaffungsumfänge QM-Planungen vor? ",
    description: ""
  },
  {
    category: 4,
    text:
      "Sind die Produkt-FMEA /Prozess-FMEA erstellt, im Projektablauf aktualisiert und sind Korrekturmaßnahmen festgelegt?",
    description:
      "In der Entwicklungsphase ist mittels FMEA sicherzustellen, dass das Produkt u. der Prozess den Anforderungen des Kunden hinsichtlich Funktion, Zuverlässigkeit ect. entspricht. Die Durchführung der FMEA muss geregelt sein. Änderungen am Produkt u. Prozess müssen neu bewertet werden. Das gleiche gilt nach Maßnahmen z. B. nach einem 8D-Report. Die FMEA muss Inhalt des Projektplans sein.Besondere Merkmale u. gesetzliche Vorgaben sind identifiziert, gekennzeichnet u. durch Maßnahmen abgesichert.Die Produktionsplanung sowie das zukünftige produzierende Werk sind Mitglieder des FMEA-Teams."
  },
  {
    category: 4,
    text:
      "Sind die Festlegungen aus den Plänen zur Produkt- und Prozessentwicklung umgesetzt?",
    description:
      "Projektablaufplanung, QFD, DOE, Einbauerprobungen, Prüfplanung, Poka Yoke-Prinzipien, Lebensdauertests, Umweltprüfungen, Prozessablaufdiagramm."
  },
  {
    category: 4,
    text: "Sind die Personal-Ressourcen vorhanden und qualifiziert?",
    description:
      "Ein Prozess der Personalplanung muss vorhanden sein. Schulungsbedarfsermittlung, Einarbeitungsnachweise, Einbringung neuer Mitarbeiter in Qualimatrix, Kapazitäten für Musterbau, Nullserie, Produktionstest u. Serienproduktion sind vorhanden.        "
  },
  {
    category: 4,
    text:
      "Ist die Infrastruktur vorhanden und geeignet?\nProzess zur Ressourcenermitttlung vorh? Verfügbarkeit von testequipment, Laboreinrichtungen, Maschinen, Anlagen. Auslastung von Maschinen? Kapazitäten in der Angebotskalkulation vorh.?",
    description:
      "Erforderlichen Mittel müssen im Projekt eingestellt sein. Transparenz von Engpässen muss im Prozess beschrieben sein (Turtle)"
  },
  {
    category: 4,
    text:
      "Sind zu den jeweiligen Phasen auf Basis der Anforderungen die erforderlichen Eignungsnachweise und Freigaben vorhanden?",
    description:
      "Freigaben der Einzelteile gemäß Entwicklungsterminpläne vorhanden, Regelmäßige Statusberichte in Anlehnung an den Projektplan, PPF d. h. Produkt und Produktionsprozessfreigaben müssen vorhanden sein, Serienfreigabe, Referenzteile auch Farbmuster aus Bemusterungen müssen gekennzeichnet und entsprechend Kundenvorgaben gelagert sein. Spezifikationen, aktuelle Zeichnungen, Lasten- u. Pflichtenhefte müssen vorhanden sein."
  },
  {
    category: 4,
    text:
      "Werden die Produktionslenkungspläne für die jeweiligen Phasen angewendet und sind Fertigungs- und Prüfungsunterlagen daraus abgeleitet?",
    description:
      "Prototypenphase wenn vom Kunden verlangt, Vorserienphase, Serienphase, Reihenfolge der Prozessschritte vorhanden, Kennzeichnung besondere Merkmale, Prüfhäufigkeit, Zyklus, Lehren u. Prüfmittel, Dokumentation der Prüfergebnisse, Klärung von Annahmekriterien, Reaktionsplan, *Verpackungsanweisung, Nacharbeit, Requalifikationsprüfung."
  },
  {
    category: 4,
    text:
      "Ist eine Vorproduktion (Produktionstest) unter Serienbedingungen für die Serienfreigabe durchgeführt?",
    description:
      "Nachweis der vereinbarten Stückzahlen d. h. Run at Rate, Prozessfähigkeit, Messmittelfähigkeit entsprechend Produktionslenkungsplan, Prüfmittelfähigkeit, Personalqualifiktion, Arbeits- u. Prüfanweisungen, Arbeitsplatzgestaltung, Erstmusterprüfung, Planung des Erstbemusterungsablaufs. Produktionstests nach Kundenvorgabe, Erkennen von Stücklisten u. Dispositionsfehlern (hier auch Fehler in den Spezifikationen."
  },
  {
    category: 4,
    text:
      "Sind die Planungsaktivitäten für Beschaffungsumfänge wirksam umgesetzt?",
    description:
      "(Überwachung des Lieferanten bezüglich Fortschritt der Projektrealisierung. Meilensteinpläne vom u. beim Lieferanten vorhanden, Verfolgung der Aktivitäten beim Lieferanten ist sichergestellt, Abweichungen werden erkannt und geeignete Maßnahmen sind eingeleitet, besondere Merkmale d. h. APQP), Gesetzesforderungen d. h. deklarierungspflichtige Stoffe, Kennzeichnung der Werkzeuge, Auditberichte, Besuchsprotokolle, Fähigkeitsnachweise, Projektberichte des Lieferanten, Toleranzbetrachtungen, Belastungstests, Referenzmuster d. h. auch Farbmuster, QM-Plan."
  },
  {
    category: 4,
    text:
      "Ist die Projektübergabe an die Serie  zur Anlaufabsicherung geregelt?",
    description:
      "(Strukturierter Übergabeprozess von der Entwicklung an die Produktion. Vor erster Serienlieferung muss interne Produktionsfreigabe (Checkliste) vorliegen.. Produktionstests gemäß Kundenvorgaben sind durchgeführt. Maßnahmen aus Produktionstests sind durchgeführt. MFU sind für alle Merkmale durchgeführt, Werkzeuge, Prüf- u. Messmittel stehen zur Verfügung. Eine Anlaufabsicherung muss für alle Neu- oder geänderte Teile, die eine Bemusterung erfordern, durchgeführt werden. "
  },
  {
    category: 5,
    text: "Werden nur freigegebene und qualitätsfähige Lieferanten eingesetzt?",
    description:
      "-(mindest. DIN ISO 9001:2008), Überprüfung der Zertifikate, Self Assessment, Potentialanalyse bei neuen, unbekannten Lieferanten, Prozessaudits, Auswahlkriterien unter Berücksichtigung der Lieferantenbewertung, Risiken in der Lieferantenkette müssen berüc"
  },
  {
    category: 5,
    text: "Werden die Kundenanforderungen in der Lieferkette berücksichtigt?",
    description:
      "Lieferanten müssen hinsichtlich der Leistung gesteuert u. überwacht werden. Die Weitergabe von Kundenanforderungen muss geregelt sein (Lastenheft+QM-Vereinbarungen) u. nachvollziehbar sein. Übermittlung von Maßen u. Toleranzen, Terminschienen, Prozessabnahmen, Freigaben, Reklamationen sowie Sicherstellung der Lieferungen bei Änderungen.\n*Ein Produktsicherheitsbeauftragter (PSB) für jede Stufe in der Lieferkette ist benannt."
  },
  {
    category: 5,
    text:
      "Sind mit den Lieferanten Zielvereinbarungen für die Lieferleistung abgestimmt und umgesetzt?",
    description:
      "Mit allen Lieferanten müssen Zielvereinbarungen für die Lieferleistung zur kontinuierlichen Verbesserung von Produkten u. Prozessen abgestimmt u. umgesetzt sein. Bei Abweichungen müssen Maßnahmen vereinbart sein u. deren Umsetzung einschließlich Termine überwacht werden. Workshops, messbare Zielgrößen wie Qualität, Preis, Service, z. B. Reduzierung des Prüfaufwands bei gleichzeitiger Erhöhung der Prozesssicherheit, Reduzierung von Ausschuss, Reduzierung des Umlaufbestands, Erhöhung der Kundenzufriedenheit, Reduzierung der ppm- Raten im Rahmen der 0-Fehler-Strategie (mindestens im jährlichen Turnus, Vermeidung von Sonderfahrten). Maßnahmen bei Abweichungen."
  },
  {
    category: 5,
    text:
      "Sind für die beschafften Umfänge die erforderlichen Freigaben vorhanden?",
    description:
      "Für alle Beschaffungsvorgänge muss vor Serieneinsatz neuer/geänderte Produkte/Prozesse eine Freigabe durchgeführt werden. Der Lieferant hat hier die volle Verantwortung! Spezifikationen, Normen, Prüfvorschriften, Baumuster-, Versuchsfreigaben, PPF-Bericht entsprechend VDA Band 2, Fähigkeitsnachweise, besondere Merkmale, Beachtung der EU-Sicherheitsdatenblätter u. Liste für deklarationsfähige Stoffe-IMDS, Reach, Auswertungen zur Zuverlässigkeit, Requalifikationsprüfungen."
  },
  {
    category: 5,
    text: "Ist die vereinbarte Qualität der Beschaffungsumfänge gewährleistet?",
    description:
      "Die Fähigkeiten u. Leistungen der Lieferanten müssen in definierten Zeiträumen überprüft und teilespezifisch in einer Aufstellung (Lieferantenkatalog) festgehalten u.ausgewertet werden. Bei negativen Ergebnissen sind Qualifizierungsprogramme festzulegen *(Lieferantenentwicklung mit Beobachtungsstufen), Mess- u. Prüfmittel sind sauber u. ordentlich gelagert (Schutz vor Beschädigung, Verschmutzung, Klimatisierung, Lichtverhältnisse), Erfassung u. Auswertung von Prüfpunkten im *QS1, gilt auch für verlängerte Werkbänke.\n*Dokumentation der Werkstoffe und Massen (Gewicht)."
  },
  {
    category: 5,
    text: "Werden die Wareneingänge zweckentsprechend gelagert?",
    description:
      "Wareneingänge sind mit QS1 zu dokumentieren.  Suspekte Anlieferungen sowie Transportschäden sind eindeutig zu kennzeichnen, zu sichern u. vor Zugriff zu schützen (Deutliche Sperr-Kennzeichnung- Sperrflächen), Erst nach einer dokumentierte Überprüfung durch die QS darf suspektes Material wieder freigegeben werden (TS16949-Forderung), Angelieferte i.O. Ware ist nach Kennzeichnung des Freigabestatus  beschädigung- u. vermischungssicher einzulagern. FIFO Prinzip wird eingehalten. Chargenrückverfolgbarkeit ist gewährleistet, Haltbarkeitsfristen bei Kleber, Harzen ect. werden beachtet, Begleitbelege sind vorhanden. Bei Rollen- und Platinenware sowie Halbfertigware ist eine Kantengerade Wicklung und Stapelgenauigkeit vorhanden, Entsprechende Transportmittel sind vorhanden."
  },
  {
    category: 5,
    text:
      "Ist das Personal für die jeweiligen Aufgaben qualifiziert und sind die Verantwortlichkeiten definiert?",
    description:
      "Es muss beschrieben sein welche Verantwortungen, Aufgaben u. Befugnisse die Mitarbeiter in Ihrem jeweiligen Augabengebiet haben. Für Funktionen muss eine Stellenbeschreibung vorliegen. Schulungsbedarfe müssen für jeden Mitarbeiter in Bezug auf die Aufgabe ermittelt u. Qualifizierungen entsprechend durchgeführt werden. Kenntnisse zu bisherigen Beanstandungen sind vorhanden. Weitere kenntnisse: Produktspezifikationen, spezielle Kundenanforderungen, Produktmerkmale, Fertigungsabläufe, Normen, Gesetze, Verpackung, Audit, Statistik, 8D- Methode, Ishikawa, Abstellmaßnahmen, Fremdsprachen bei ausländischen Lieferanten.\n*Die Audits in der Lieferkette müssen von entsprechend qualifizierten VDA 6.3 Auditoren durchgeführt werden (siehe auch VDA 6.3: Anforderungen an Prozessauditoren in der Lieferkette).\n"
  },
  {
    category: 6,
    text: "Was geht in den Prozess hinein? Prozesseingabe / Input",
    description: "Was geht in den Prozess hinein? Prozesseingabe / Input"
  },
  {
    category: 6,
    text:
      "Ist die Projektübergabe von der Entwicklung an die Serien-Produktion erfolgt?",
    description:
      "Ein Prozess zur Übergabe der Verantwortung zwischen Entwicklung und Produktion ist definiert u. geregelt. PPF ist durchgeführt worden. Anlaufabsicherung ist etabliert. MFU`s für alle relevanten Merkmale sind nachgewiesen. Werkzeuge, Prüf- u. Messmittel stehen in notwendiger Anzahl zur Verfügung."
  },
  {
    category: 6,
    text:
      "Sind die benötigten Mengen/Fertigungslosgrößen der Vormaterialien zum vereinbarten Zeitpunkt am richtigen Lagerort/Arbeitsplatz verfügbar?",
    description:
      "Das richtige Produkt (Vormaterial, Bauteil, Komponente…) muss in der vereinbarten Qualität, in der richtigen Menge, in der richtigen Verpackung, mit der richtigen Dokumentation zum vereinbarten Zeitpunkt am vereinbarten Platz sein. Stellplätze, definierte Lagerplätze, Kanban, Just in time, FIFO, Erfassung -Restmengen nach Auftragsende, minimale Lagermengen auf den Fertigungsbedarf abgestimmt."
  },
  {
    category: 6,
    text:
      "Werden die Vormaterialien zweckentsprechend gelagert und sind die Transportmittel / Verpackungseinrichtungen auf die speziellen Eigenschaften der Vormaterialien abgestimmt?",
    description:
      "Kundenspezifische Verpackungsvorschriften müssen durchgängig berücksichtigt u. umgesetzt werden, Bauteile müssen auch während der Fertigung u. des innerbetrieblichen Transports *(z. B. Dornstapler) sowie beim Transport zu u. von Dienstleistern durch geeignete Transporteinheiten vor Beschädigung u. Verschmutzung geschützt werden. Lagerplätze, Arbeitsplätze, Behälter müssen ordenlich gelagert u. sauber sein. 5S-Methodik. Reinigungszyklen sind definiert u. werden überwacht. *Höchst- u. Mindestlagerzeiten werden eingehalten, Kritische Betriebs- u. Hilfsstoffe sind gegen Umwelt-/Klimaeinflüsse zu schützen."
  },
  {
    category: 6,
    text:
      "Sind die erforderlichen Kennzeichnungen/Aufzeichnungen/Freigaben vorhanden und den Vormaterialien entsprechend zugeordnet?",
    description:
      "Freigegebene Vormaterialien müssen eindeutig gekennzeichnet u. erkennbar sein. Der Freigabestatus muss aus der Kennzeichnung hervorgehen. Die Kennzeichnung an den Gebinden/Chargen/Ladungsträgern/Bauteilen muss festgelegt sein. Kundenspezifische Vorgaben für die Freigabe von Produkten sind zu berücksichtigen. Sicherstellung, dass nur freigegebene Materialien/Teile der Fertigung bzw. dem nächsten Fertigungsschritt zugeführt u. verbaut werden. Die Rückverfolgbarkeit muss über die gesamte Prozesskette gewährleistet sein. Kundenvorgaben sind hierzu zu berücksichtigen. Ersatzteile sind speziell zu kennzeichnen. Gesetzliche Anforderungen u. das Produkthaftungsgesetz sind zu berücksichtigen. Merkmale mit besonderer Anforderung an die Dokumentation u. Archivierung werden aufgezeichnet).\n*Kennzeichnung nach Kundenvorgaben (Materialkarte VDA 4902), Plausibilität (Barcodeinhalte)."
  },
  {
    category: 6,
    text:
      "Werden Änderungen am Produkt oder Prozess während der Serie verfolgt und dokumentiert? ",
    description:
      "Verantwortlichkeiten für Änderungen müssen geregelt sein. Ein Prozess der die Änderungsfreigabe regelt muss vorhanden sein. Die Dokumentation der Änderungsstände muss durchgängig nachvollziehbar sein. Sicherstellung, dass jederzeit der richtige Konstruktionsstand der Fertigprodukte produziert und an den Kunden geliefert wird. Merkmale mit besonderen Anforderungen werden entsprechend verfolgt u. dokumentiert. Sicherstellung, dass an den Arbeitsplätzen nur gültige und aktuelle Dokumente vorliegen."
  },
  {
    category: 6,
    text:
      "Arbeitsinhalte / Prozessablauf (Sind alle Produktionsprozesse geregelt?)",
    description:
      "Arbeitsinhalte / Prozessablauf (Sind alle Produktionsprozesse geregelt?)"
  },
  {
    category: 6,
    text:
      "Sind auf Basis des Produktionslenkungsplans in den Fertigungs- und Prüfunterlagen die relevanten Angaben vollständig aufgeführt?",
    description:
      " Die *aktuellen, unterschriebenen Fertigungs- u. Prüfunterlagen (Produktionslenkungsplan, Arbeitsplan, Fertigungshinweise, Arbeitsanweisungen) müssen am Arbeitsplatz verfügbar sein. Prüfmerkmale, -mittel, - methoden,- häufigkeiten/ zyklen, Requalifikation müssen darin beschrieben u. definiert sein.. Prozessparameter, die Einfluss auf die Produkteigenschaften haben müssen vollständig u. mit Toleranzen vorhanden sein. Die Eingriffsgrenzen in den Prozessregelkarten müssen festgelegt, erkennbar u. nachvollziehbar sein.Abweichungen u. eingeleitete Maßnahmen sind zu dokumentieren u. *zu bewerten). Nacharbeitsbedingungen sind spezifiziert und im Prozess abgesichert d. h. Kennzeichnung der Teile, erneute Prüfung etc. *Rüstzeiten sind zu bewerten und zu optimieren. Sind die Mitarbeiter im Umgang mit den Fertigungsunterlagen aktuell geschult und finden Wiederholungsschulungen mit Nachweis in regelmäßigen Abständen statt?"
  },
  {
    category: 6,
    text:
      "Erfolgt eine Freigabe von Fertigungsabläufen und werden Einstelldaten erfaßt?",
    description:
      "Es muss eine Auftragsbezogene Freigabe *(Erststückprüfung) eines Prozesses erfolgen (Dazu gehören auch Unterprozesse z. B. Kleben, Löten, Schweissen). Bis zur offiziellen, schriftlichen Freigabe sind die Teile zu sperren und entsprechend zu kennzeichnen. Bei Störungen u. Maschinenstillstände sowie bei Beginn einer neuen Schicht oder neuen Charge hat jeweils eine neue Freigabe zu erfolgen. Die Freigaben erfolgen durch authorisierten Mitarbeitern. Freigegebene Prüf- u. Grenzmuster sind an den Arbeitsplätzen vorhanden. Abweichungen u. eingeleitete Maßnahmen sind dokumentiert."
  },
  {
    category: 6,
    text:
      "Können mit den Fertigungseinrichtungen die produktspezifischen Anforderungen für den Kunden erreicht werden?",
    description:
      "Es muss nachgewiesen werden, dass die Kundenanforderungen mit den vorhandenen Produktionseinrichtungen erfüllt werden können. Für wichtige Produkt- u. Prozessmerkmale sind die Prozessfähigkeiten zu ermitteln.u. kontinuierlich nachzuweisen. Für die Maschinenenfähigkeit (Kurzzeitprozessfähigkeit muss CMK/PPk > 1,67 erreicht werden. Für die langfristige Prozessfähigkeit CPK gilt die Mindestfordereung > 1,33. Für besondere Merkmale, für die eine Fähigkeit nicht nachgewiesen werden kann, ist eine 100% Prüfung erfoderlich. Beispiele von Regelungen: Zwangssteuerungen d. h. bei Prozessabweichungen hält die Maschine an, Poka Yoke-Überwachungen, Lampe, Hupe. Aufnahmen, Fixierungen müssen reproduzierbar sein. Maschinen- u. Werkzeugwartungen müssen plangemäß erfüllt sein.\n*Stellglieder für prozessbeeinflussende Parameter müssen vor unbefugten Eingriffen geschützt sein."
  },
  {
    category: 6,
    text: "Werden besondere  Merkmale in der Produktion gelenkt?",
    description:
      'Besondere Produktmerkmale sind im PLP (Produktionslenkungsplan gekennzeichnet u. werden systematisch mittels SPC überwacht. Bei Abweichungen wird wirksam gegengesteuert.Aufzeichnungen über Abweichungen u. Gegenmaßnahmen werden geführt. Abweichungen auf die Eigenschaften des Produkts haben müssen vom Kunden genehmigt werden *(Sonderfreigabe) Fertigungsprozesse sind beherrscht und prozessfähig). Produktaudit werden durchgeführt.\n*Technische Unterlagen zu D/TLD-Teilen mit gültigem Änderungsstand vorhanden, als D/TLD gekennzeichnet u. die D/TLD- Merkmale besonders ausgewiesen.\nHinweis* Verwendet der Lieferant eine andere Kennzeichnung für seine Dokumente und Aufzeichungen muss er eine Korrelationsdarstellung für die o. g. Kennzeichnungspflicht ( z. B. Übersichtsmatrix mit den Kennzeichnungen für sämtliche Kunden u. der internen Kennzeichnung) als gelenkte Vorgabedokumentation führen.\nVollständige Abarbeitung des Anforderungskataloges:\n> Auditplan\n> zu D/TLD Formel Q Fähigkeit oder vergleichbar\n> zu D/TLD mindestens 15 Jahre Archivierung\n- Festlegung u. Verfolgung von Verbesserungsprogrammen\n- Einbeziehung von Unterlieferanten\n- Schriftliche Bestätigung gesetzeskonformer Bauteile, ZSB\n  ect.\n- Daten in IMDS vollständig u. aktuell\n- Volkswagen Normen, vor allem VW 91101, Stoffliste siehe  \n   IMDS (www.mdsystems.com)\n- Übersichtsliste "nachweispflichtige Teile an den \n   VOLKSWAGEN Konzern" (D/TLD)\n- Durchführung von D/TLD-Selbstaudits mindestens einmal \n  pro Jahr. Das Selbstaudit darf nicht länger als ein Jahr\n  zurückliegen\n- Datumseingabe des letzten D/TLD Selbstaudits in BeOn.\n- Spezifikationen, Bemusterungsunterlagen für den\n  Volkswagen Konzern\n- Produktkennzeichnung entsprechend den nationalen u.\n  internationalen Konformitätsanforderungen (z. B. CCC,\n  ECE, DOT...).'
  },
  {
    category: 6,
    text:
      "Werden Ausschuß-, Nacharbeits- und Einrichtteile sowie innerbetriebliche Restmengen konsequent separiert und gekennzeichnet?\nBesondere Produktmerkmale sind im PLP (Produktionslenkungsplan gekennzeichnet u. werden systematisch mittels SPC überwacht. Bei Abweichungen wird wirksam gegengesteuert.Aufzeichnungen über Abweichungen u. Gegenmaßnahmen werden geführt. Abweichungen auf die Eigenschaften des Produkts haben müssen vom Kunden genehmigt werden *(Sonderfreigabe) Fertigungsprozesse sind beherrscht und prozessfähig). Produktaudit werden durchgeführt.",
    description:
      "Besondere Produktmerkmale sind im PLP (Produktionslenkungsplan gekennzeichnet u. werden systematisch mittels SPC überwacht. Bei Abweichungen wird wirksam gegengesteuert.Aufzeichnungen über Abweichungen u. Gegenmaßnahmen werden geführt. Abweichungen auf die Eigenschaften des Produkts haben müssen vom Kunden genehmigt werden *(Sonderfreigabe) Fertigungsprozesse sind beherrscht und prozessfähig). Produktaudit werden durchgeführt."
  },
  {
    category: 6,
    text:
      "Ist der Material- und Teilefluß gegen Vermischung/Verwechslung abgesichert?",
    description:
      "Durch einen geeigneten Material- u. Teilefluss werden Vermischungen ausgeschlosen ggf. durch Poka Yoke Maßnahmen. Ein Falschverbau muss ausgeschlossen werden bzw. direkt erkannt werden. Geeignete Prüfungen u. Maßnahmen sind zu ergreifen, die eine frühzeitige Erkennung u. Ausschleusung falsch verbauter Teile gewährleisten.Entsprechende Themen u. Maßnahmen müssen in der P-FMEA berücksichtigt sein. Ein Prozess zur Wiedereinführung von Restmengen, separierter Teile (z. B. Teile die aufgrund einer Anlagenstörung abgestapelt sind) sowie Teile aus Produktaudits, Prüfteile, ect. muss eindeutig geregelt sein. Behälter und Teile müssen gekennzeichnet sein. *Der Status der Teile muss jederzeit erkennbar sein. Verfalldatum und Höchstlagerzeit repektive Bauteilen muss beachtet werden. Restmengen sind gekennzeichnet, dokumentiert und entsprechend gelagert.\n*- Kennzeichnung nach Kundenvorgaben\n - (Materialkarte VDA 4902), Plausibilität (Barcodeinhalte)"
  },
  {
    category: 6,
    text: "Prozessunterstützung / Personelle Ressourcen",
    description: "Prozessunterstützung / Personelle Ressourcen"
  },
  {
    category: 6,
    text:
      "Sind den Mitarbeitern Verantwortung und Befugnisse zur Überwachung der Produkt-/Prozessqualität übertragen?",
    description:
      "Verantwortungen, Befugnisse, Aufgaben müssen für die einzelnen Aufgabengebiete beschrieben sein z. b. *wer darf Prozessfreigaben erteilen u. Erststückprüfungen durchführen, wer führt die Prozessregelkarten, wer hat Sperrbefugnis, wer darf den Prozess anhalten? *Wer überprüft die Prüf- u. Messmittel und korrigiert ggf.? Das Qualitätsbewusstsein muss gefördert werden. *Qualitätsziele, QM-Politik und Umweltpolitik hängt in den einzelnen Abteilungen aus. Produktschulungen werden durchgeführt. Informationen zum Qualitätsergebnis zu den Kunden werden bereitgestellt (Infoboard). Rückmeldungen zu eingereichten Verbesserungsvorschlägen erfolgen, Mitarbeiter sind im KVP-Prozess mit eingebunden). Sind Produkthaftungsschulungen durchgeführt worden?"
  },
  {
    category: 6,
    text:
      "Sind die Mitarbeiter geeignet, die gestellten Aufgaben zu erfüllen und wird deren Qualifikation aufrecht erhalten?",
    description:
      "Für jeden Arbeitsplatz muss eine Stellenbeschreibung einschließlich Anforderungsprofil vorliegen. Schulungsbedarfe müssen für jeden Mitarbeiter individuell ermittelt werden *(Qualimatrix). Diese Dokumentation muss bei der Personaleinsatzplanung berücksichtigt werden. Die Mitarbeiter sind in den Prozesse geschult und kennen potenziell auftretende Fertigungsfehler. Alle Mitarbeiter sind über die Folgen fehlerhafter Arbeitsausführung  (Produktschulung)  sowie im Umgang mit Prüfmitteln, Arbeitssicherheit, Umweltaspekte geschult. *Für den Umgang mit besonderer Nachweisführung (z.B. CCC-Lieferlisten im Versand) ist eine besondere Unterweisung durchzuführen. Eignungsnachweise, die für die jeweilige Tätigkeit erforderlich sind, müssen vorliegen z. B. Staplerführerschein, Schweisserzeugnis, Lötpass, Sehtest, Hörtest, ect.) \nEinarbeitungspläne für neue Mitarbeiter, Ersatz- und \nLeihpersonal müssen vorhanden sein. Einarbeitungs-\nphasen müssen nachgewiesen werden. Bei\nÄnderungen am Produkt u. Prozess werden \nSchulungen/Unterweisungen durchgeführt u. dokumentiert."
  },
  {
    category: 6,
    text: "Gibt es einen Personaleinsatzplan?",
    description:
      "(Bei der Personaleinsatzplanung sind die Qualifikationen der Mitarbeiter zu berücksichtigen (Qualifikationsmatrix). Abwesenheitskennzahlen (Krankheit/Urlaub/ Schulung) fließen in die Einsatzplanung mit ein. Für Ersatzpersonal und/ oder ausgeliehenes Personal sind die erfoderlichen Qualifikationen sicherzustellen. Die Vertreterregelung ist dokumentiert u. resultiert aus der Qualifikationsmatrix für die jeweiligen Fertigungsabschnittte)."
  },
  {
    category: 6,
    text: "Materielle Ressourcen",
    description: "Materielle Ressourcen"
  },
  {
    category: 6,
    text:
      "Wird die Wartung und Instandhaltung der Fertigungseinrichtungen/Werkzeuge vorbeugend gelenkt?",
    description:
      "Anlagen, Einrichungen, Maschinen u. Werkzeuge, die zum reibungslosen Betreiben von Schlüsselprozessen nötig sind, sind ermittelt und mit entsprechenden vorbeugenden Wartungsintervallen vorgesehen. Ressourcen zur zur Durchführung notwendiger Instandhaltungsmaßnahmen sind vorhanden. Notwendige Instandhaltungsmaßnahmen werden systematisch durchgeführt (Wartungspläne) Vorbeugende Instandhaltungen werden durchgeführt, dokumentiert u. gesteuert. "
  },
  {
    category: 6,
    text:
      "Können mit den eingesetzten Meß-, und Prüfeinrichtungen die Qualitätsforderungen wirksam überwacht werden?",
    description:
      "Die eingesetzen Prüf- u. Messmittel sind im Produktionslenkungsplan aufgeführt, Messmittelfähigkeitsanalysen MSA u. Prüfmittelfähigkeitsanalysen (MSA-Attributiv) sind durchgeführt. Ein Prozess zur Prüfmittelüberwachung ist installiert. Zubehör für Messeinrichtungen, die Einfluss auf das Messergebnis haben, werden in gleicher Weise überwacht.\n*- Prüfeignung - Berücksichtigung der Messunsicherheit in\n    Prüfprozessen (VW 10119)\n - VDA Band 5"
  },
  {
    category: 6,
    text: "Sind die Arbeits- und Prüfplätze den Erfordernissen angemessen?",
    description:
      "Umgebungsbedingungen sind auf die Produkte abgestimmt *z. B. Trennung der Produktions Links/Rechts Teile. Verschmutzung, Beschädigung u. Verwechslung u. *Vermischung wird vorgebeugt. Arbeitsplätze sind ergonomisch gestaltet. *Die Unfallverhütungsvorschriften werden eingehalten z. B. Zweihandschaltung, Schutzhandschuhe, Schutzbrille, LDR-Schranken.Transportwege sind frei befahrbar/begehbar. Fluchtwege sind frei. Feuerlöscheinrichtungen sind überprüft u. frei zugänglich. Leitern sind sicher. Krane sind regelmäig überprüft, Verbandskästen sind im ordnungsgemäßen Zustand. Betriebssicherheitsverordnung BGI 694- Umgang mit Leitern wird befolgt."
  },
  {
    category: 6,
    text: "Werden Werkzeuge, Einrichtungen und Prüfmittel sachgemäß gelagert?",
    description:
      "Werkzeuge u. Prüfmittel sind sachgemäß gelagert u. verwaltet. Alle Werkzeuge, Prüfmittel sind mit jeweiligen Status und Änderungsstand gekennzeichnet *und entsprechend dokumentiert gewartet (Werkzeugkarten, Werkzeuglebensläufe, Wartungspläne, Reparaturbücher für Anlagen oder Peripheriegeräte. Ordnung u. Sauberkeit sowie Schutz gegen Umwelteinflüsse ist sichergestellt *z. B. Alle nicht benutzten Prüfvorrichtungen sind abgedeckt. Die Ausgabe u. Verwendung ist geregelt/ festgelegt u. wird dokumentiert."
  },
  {
    category: 6,
    text:
      "Prozesswirkungsgrad (Effektivität, Effizienz u. Vermeidung von Verschwendung integrieren)",
    description:
      "Prozesswirkungsgrad (Effektivität, Effizienz u. Vermeidung von Verschwendung integrieren)"
  },
  {
    category: 6,
    text: "Sind für Produkt und Prozess Zielvorgaben vorhanden?",
    description:
      "(Produkt- u. Prozesskennzahlen sind definiert, erfasst u. Soll/Ist-Vergleich durchgeführt z. B. Maschinenverfügbarkeit, An- u. Abwesenheit des Personals, Ausschussquote, Anzahle gefertigter Teile, Nacharbeit, Durchlaufzeiten). Prozessspezifische Ziele sind festgelegt und werden überwacht u. kommuniziert. Abweichungen werden analysiert und Verbesserungsmaßnahmen sind eingeführt. Verbesserungspotenzial wird kontinuierlich ermittelt)."
  },
  {
    category: 6,
    text: "Werden Qualitäts- und Prozessdaten auswertbar erfasst?",
    description:
      "Qualitätsregelkarten werden geführt; Prozessdaten/Prozessparameter überwacht mit Soll/Istvergleich und Dokumentation. Maßnahmen bei Prozessstörungen eingeleitet u. dokumentiert. Abweichungen bei freigegebenen Prozessen, die Auswirkungen auf das Produkt haben, sind vom Kunden freizugeben *(Sonderfreigabe). Fehlerarten und Häufigkeiten werden erfasst, ausgewertet u. Maßnahmen eingeleitet. Fehlerkosten werden Verursachergemäß erfasst u. ausgewertet.\n*Prozessfähigkeitsuntersuchung für Messbare Merkmale \n (VW 10131)."
  },
  {
    category: 6,
    text:
      "Werden bei Abweichungen von Produkt- und Prozessanforderungen die Ursachen analysiert und die Korrekturmaßnahmen auf Wirksamkeit überprüft?",
    description:
      "Geeignete Sofortmaßnahmen bei auftretenden Produkt/Prozessabweichungen werden durchgeführt. Geignete Methoden *(Ishikawa, 5 why) zur Ursachenanalyse werden eingesetzt. Korrekturmaßnahmen werden abgeleitet, Umsetzung überwacht, Wirksamkeit verifiziert. Produktionslenkungsplan und FMEA, *Arbeitsanweisung, Prozess sind entsprechend angepasst). *Bei Wiederholungsfehlern wird eine KVP-Analyse durchgeführt."
  },
  {
    category: 6,
    text: "Werden Prozesse und Produkte regelmäßig auditiert?",
    description:
      " Für Produkt und dessen Herstellungsprozess müssen Auditpläne vorliegen *(Produkt- u. Proozessauditpläne). Auditanlässe:\n- Neue Produkte oder Prozesse\n- Aufzeigen von Verbesserungspotenzial\n- Nachweisführung der Einhaltung von Qualitätsforderungen.\nAbweichungsberichte sind an die Verantwortlichen zugeleitet. Verbesserungsmaßnahmen sind zu verfolgen. Kundenanforderungen und relevante Funktionen sind berücksicht. Die Qualifikation der Auditoren sind gewährleistet und *nachweisbar.\n*Produktkennzeichnung entsprechend den nationalen u.\n internationalen Konfirmitätsanforderungen (z. B. CCC, ECE, \n DOT..)"
  },
  {
    category: 6,
    text: "Was soll der Prozess leisten? Prozessergebnis (Output)",
    description: "Was soll der Prozess leisten? Prozessergebnis (Output)"
  },
  {
    category: 6,
    text:
      "Werden in Bezug auf Produkt und Prozess die Kundenanforderungen erfüllt?",
    description:
      "Prozessspezifische Ziele aus Kundenvogaben sind festgelegt (CPK). Prüfungen u. Prüfverfahren sind mit dem Kunden abgestimmt u. dokumentiert. Kundenanforderungen werden intern auditiert (Versandaudits). Ein Prozess zum Umgang mit bereitgestellten Produkten ist implementiert. Ein Prozess zur Ausliefersperre ist installiert und die Kommunikationswege sind geregelt."
  },
  {
    category: 6,
    text:
      "Sind die Mengen/Fertigungslosgrößen auf den Bedarf abgestimmt und werden sie gezielt (Lagerort/Arbeitsplatz) zum nächsten Prozess-Schritt weitergeleitet?",
    description:
      "Geignete Transportmittel sowie definierte Lager-/Stellplätze sind vorhanden. Die Bedarfsgerechte Weiterleitung von Teilen/Vormaterialien ist geregelt. Die Teilekennzeichnung muss festgelegt sein. Stückzahlerfassung u. Auswertung ist geregelt. Umhang mit n.I. O. Teilen ist geregelt. Kundenvorgaben für Kennzeichnung nachgearbeiteter Teile sind umgesetzt.\n*-Ausgelagerte Prozessschritte ( zusätzliche Produktrisiken\n  in der Transportkette z. B. durch Teilehandling,  \n  Transportstrecken, ect.).\n- First-in-First out"
  },
  {
    category: 6,
    text:
      "Werden Produkte/Bauteile zweckentsprechend gelagert und sind die Transportmittel/Verpackungseinrichtungen auf die speziellen Eigenschaften der Produkte/Bauteile abgestimmt?",
    description:
      "Der Schutz vor Beschädigung bei Lagerung u. Verpackung ist gewährleistet. Die Kundenspezifische Verpackungsvorschrift ist umgesetzt. Ordung u. Sauberkeit ist an den Lagerplätzen/Behältern gegeben. Vorgegebene Lagerzeiten/Haltbarkeitszeiten werden überwacht. Schutz der Bauteile gegenüber Umwelt- /Klimaeinflüssen ist gegeben). Paletten u. Behälterkennzeichnungen sind mit den Lieferpapieren konform. Bei veralteten Produkten oder bei Produkten deren Kennzeichnung verloren gegangen ist muss von der QS über die Verwendbarkeit oder Verschrottung entschieden werden). Beschädigte Ldungsträger werden gesperrt, gekennzeichnet u. getrennt gelagert. Regalsysteme sind unbeschädigt.\n* - Lage der Kennzeichnung (Kartentasche/Halterung\n  - Entfernung ungültiger Kennzeichnungen"
  },
  {
    category: 6,
    text:
      "Werden die erforderlichen Kennzeichnungen/Aufzeichnungen/Freigaben geführt und entsprechend archiviert?",
    description:
      "Ein Prozess zur Freigabe von Produkt und Prozess muss vorhanden sein. Die Kennzeichnung der Freigaben ist festgelegt. Aufzeichnungen über Freigaben sind dokumentiert und archiviert. *Einrichtpläne sind vorhanden. Sonderfreigaben/Abweicherlaubnisse sind gekennzeichnet und dokumentiert. Rückverfolgbarkeit der Produkte muss sichergestellt sein (Chargenkennzeichnung). *Ungültige Kennzeichnungen werden entfernt. Archivierungsvorgaben sind festgelegt). Zwischenprüfungen, *Endkontrollen werden anhand der Vorgaben im Produktionslenkungsplans korrekt u. dokumentiert durchgeführt."
  },
  {
    category: 7,
    text:
      "Werden die Kundenanforderungen bezüglich QM-System, Produkt (bei Auslieferung) und Prozess erfüllt?",
    description:
      'Zertifiziertes System nach Kundenanforderungen. Aktuelle Kennzahlen zur Kundenzufriedenheit, Nachweisführung zu besonderen Merkmalen (Dokumentationspflicht), Verpackungsforderungen des Kunden, Produktrequalifikation, Ersatzteilversorgung, Gesetzeskonformität.\n*- QM-System-Zertifizierung ISO 16949 alternativ VDA 6.1\n - Zielvereinbarungen zu Null- Fehler Anspruch nach Formel\n   Q Fähigkeit\n - Umsetzung der Forderungen Formel Q- Neuteile integral\n   (QPN), inkl. Abnahme der 2-Tages Produktion (2 TPE)\n - Datenfernübertragung ( z. B. DFÜ VDA Standart 4929) \n   nach  "EDI Implementation Guidelines" Volkswagen AG.\n- Zertifikate zum Nachweis der Konformität mit nationalen u.\n  internationalen Vorschriften ( z. B. CCC, ECE, DOT, ect.).\n  Die Entziehung von Zertifikaten/Freigaben, muss an die\n  abnehmenden VOLKSWAGEN Konzern Kundenwerke u.\n  an die Ansprechpartner in Beschaffung u. \n  Qualitätssicherung des VOLKSWAGEN Konzerns u. der   \n  Beteiligungsgesellschaften unverzüglich gemeldet\n  werden.'
  },
  {
    category: 7,
    text: "Ist die Kundenbetreuung gewährleistet?",
    description:
      "Ansprechpartner/Kommunikation, Kenntnisse zum Produkteinsatz, Produkt- und Prozessveränderung/Verlagerungen, Abweichungen von Forderungen (auch Verpackung u. Transport), Zugriff auf Kundenportale.\n*- Pflege der Lieferantendatenbank (LDB-B2B): u. a.\n   Kontaktdaten, Leistungsspektrum/ DUNS Nr./ Krais Nr.\n - Freischaltung Zugang zur VOLKSWAGEN Konzern\n   Kommunikationsplattform (B2B-Plattform)\n - Erst-/Wiederholungsbemusterung standortspezifisch\n   mit DUNS Nr. des produzierenden Standortes."
  },
  {
    category: 7,
    text: "Ist die Teileversorgung sichergestellt?",
    description:
      "(Notfallpläne, Kommunikation intern u. extern, Kapazitäten intern u. extern, Entscheidungsbefugnisse / Eskalationsverfahren)."
  },
  {
    category: 7,
    text:
      "Werden bei Abweichungen von Qualitätsanforderungen Fehleranalysen durchgeführt und Korrekturmaßnahmen wirksam umgesetzt? (Qualitätsregelkreis)",
    description:
      "Analysemöglichkeiten (Labor, Prüf-/ Testeinrichtungen, Personal, Analyse zu Fehlermerkmalen (intern/extern), Einsatz von Problemlösungsmethoden *z. B. Ishikawa, Wirksamkeitsprüfungen *nach Implementierung von Maßnahmen, Wissensspeicher, Lessons Learned.\n*- Wesentliche Analyse-/Prüfmöglichkeiten im Hause\n    (Labor, Prüf-/Testmöglichkeiten, Personal)."
  },
  {
    category: 7,
    text:
      "Gibt es einen Prozess der die Schadteilanalyse wirksam sicherstellt?",
    description:
      "Prüfspezifikationen festgelegt, NTF-Leitfaden festgelegt, Prüfeinrichtungen und Personal, Qualitätsberichte, Wirksamkeit."
  },
  {
    category: 7,
    text:
      "Ist das Personal für die jeweiligen Aufgaben qualifiziert und sind die Verantwortlichkeiten definiert (Prozesseigner)?",
    description:
      "Kunden-, Normen-, und Gestzesanforderungen, Qualitätstechniken und -methoden, Fremdsprachen, Schulungspläne und - nachweise, Stellvertreterregelung.\n*- Externe Qualifizierung mindestens eines Mitgliedes des \n    Managements zu den Grundsätzen des Produktsicherheits- \n    u. Produkthaftungsrechts.\n - Produktsicherheitsbeauftragter (PSB) in der \n   Lieferantendatenbank (LDB-B2B) benennen\n - Das Selbstaudit muss von entsprechend qualifizierten\n   VDA    6.3 Auditoren durchgeführt werden (siehe VDA\n   6.3: Anforderungen an Interne Auditoren."
  }
];
